import { TabLabel } from '@app/fallback-report/table-nav/table-nav.component';

/**
 * this method must be bound to a class with DataEndpoint and is meant
 * to consume TableNavOverrides with keys matching endpoint names -- see ComEd
 * example
 **/
export function factoryOpCoTabLabels(): Array<TabLabel> {
  return this.TabOrder
/*    .filter(key => new RegExp('^' + this.opCo).test(key)) */
    .map(key => ({
      text: this.TableNavOverrides[key] || key
        .replace(this.opCo, '')
        .split(/(?=[A-Z])/)
        .join(' '),
      payload: { endpoint: this.DataEndpoint[key] }
    }));
}
